module.exports = __webpack_public_path__ + "img/hgqygl.3274bcf8.png";